import useCarouselState from '@/app/(site)/(static)/about/sections/values/hooks/use-carousel-state'
import Button from '../button'
import { cn } from '@/util/cn'
import { HTMLAttributes } from 'react'
import SlideComponent from '../slide'
import SlideDesktopNavigation from '../slide-desktop-navigation'
import { motion } from 'framer-motion'
import { IMAGE_PATH } from '@/app/(site)/(static)/about/config/constants'

type Props = {
    state: ReturnType<typeof useCarouselState>
} & HTMLAttributes<HTMLDivElement>

const DesktopLayout = ({ state, className, ...rest }: Props) => {
    return (
        <div className={cn('grid grid-cols-2 bg-giphyDarkestGrey rounded-xl min-h-[27rem] md:min-h-[39rem] relative', className)} {...rest}>
            <SlideComponent 
                {...state.activeSlide}
                animationHandlers={state.animationHandlers}
                endContent={<SlideDesktopNavigation isDisabled={state.isAnimating} onNext={state.goToNextSlide} onPrev={state.goToPrevSlide} />}
            />
            
            <motion.div layout className="grid grid-cols-2 gap-2 px-4 lg:px-20 place-content-center">
                {state.slides.map((slide, index) => (
                    <Button 
                        key={index} 
                        gradientClassName={slide.gradientClassName}
                        isActive={state.isActiveSlide(index)}
                        onClick={() => state.setActiveIndex(index)}
                    >{slide.name}</Button>
                ))}
            </motion.div>

            <img alt="" src={`${IMAGE_PATH}/values-bottom.gif`} className="absolute max-w-[14rem] w-[18%] -bottom-6 right-14 h-auto aspect-square" />
        </div>
    )
}

export default DesktopLayout
